import { number_format, tracking, sendChameleonAndHeapTrackEvent } from '@bark/bark-core';
import {
	initCardModal,
	confirmSetupIntent,
	taxWord,
	clearModal,
	showCardModal as ccShowCardModal,
	showModalErrorText,
	retryIntent,
} from '../../components/payments/credit-card';
import { trackingPayload } from './cs-subscription-tracking';
import {
	createSubscriptionForPackage,
	createSubscriptionForPrebuiltPackage,
	deleteSubscriptionForPrebuiltPackage,
} from './cs-subscription-api';
import { getPrimaryPaymentMethod } from '../../components/payments/payment-methods';
import CsSubscriptionPaymentSummaryModal from './cs-subscription-payment-summary-modal';
import { showThankyouMessage } from './cs-subscription-common';

export default function () {
	let $cardModal = null;
	let paymentMethod = null;
	let packages = [];
	let selectedPackage = {};
	let selectedPaymentFrequency = 'month';
	let currencySymbol = '';

	const init = async (csPackages, curSymbol) => {
		$cardModal = initCardModal(
			'.js-card-payment-modal',
			onCardModalSuccess,
			() => {},
			() => {},
		);

		await refreshPaymentMethod();

		packages = csPackages;

		currencySymbol = curSymbol;

		return;
	};

	const refreshPaymentMethod = async () => {
		paymentMethod = await getPrimaryPaymentMethod($cardModal.data('seller-profile-id'));
		return;
	};

	const processPaymentForPackage = (packageName) => {
		selectedPackage = packages.find(({ name }) => name === packageName);
		if (selectedPackage) {
			paymentMethod?.id ? showPaymentSummaryModal() : showCardModal();
			tracking('credit-subscription-self-service-page-checkout', 'card_on_file', {
				...trackingPayload,
				card_on_file: paymentMethod?.id ? 'Yes' : 'No',
			});

			$('#js-cs-sub-payment-modal-terms-link a')
				.off('click')
				.on('click', function (e) {
					tracking(
						'credit-subscription-self-service-page-checkout',
						'click_terms_and_conditions',
						trackingPayload,
					);
				});
		}
	};

	const showCardModal = (updateCard = false, cardError = '') => {
		const { Handlebars } = window;
		const modalHeaderTemplate = Handlebars.compile(
			document.getElementById('cs-sub-payment-modal-header').innerText,
		);
		const modalPackSummaryTemplate = Handlebars.compile(
			document.getElementById('cs-sub-payment-modal-pack-summary').innerHTML,
		);
		const modalTermsLink = Handlebars.compile(
			document.getElementById('cs-sub-payment-modal-terms-link').innerHTML,
		);

		$(
			'.js-card-payment-modal .modal-header #js-cs-sub-payment-modal-pack-summary',
		).remove();
		$('.js-card-payment-modal .modal-header').append(
			modalPackSummaryTemplate({
				packageName: selectedPackage?.name === 'silver' ? 'Recommended' : 'Custom',
				creditsPerMonth: selectedPackage?.credits_per_month,
				creditsPerWeek: selectedPackage?.credits_per_week,
				pricePerMonth:
					currencySymbol +
					number_format(selectedPackage?.price_per_month_in_pence / 100, 2),
				pricePerWeek:
					currencySymbol +
					number_format(selectedPackage?.price_per_week_in_pence / 100, 2),
				pricePerCredit: selectedPackage?.price_per_credit_in_pence
					? currencySymbol +
					  number_format(selectedPackage.price_per_credit_in_pence / 100, 2)
					: '',
				isWeekly: selectedPaymentFrequency === 'week',
				isMonthly: selectedPaymentFrequency === 'month',
			}),
		);

		if (!$('.js-card-payment-modal #js-cs-sub-payment-modal-terms-link').length) {
			$(modalTermsLink()).insertAfter('.js-card-payment-modal .modal-footer');
		}

		$(
			'#js-cs-sub-payment-modal-update-card-sub, #js-cs-sub-payment-modal-update-card-title',
		).remove();
		if (updateCard) {
			$('.js-card-payment-modal .modal-body')
				.prepend(
					'<p id="js-cs-sub-payment-modal-update-card-title">Update your card on file:</p>',
				)
				.append(
					'<p id="js-cs-sub-payment-modal-update-card-sub" class="text-regular text-xs mt-4">This card will be used for current and all future payments</p>',
				);
		}

		ccShowCardModal($cardModal, {
			headerText: modalHeaderTemplate(),
			confirmText: 'Subscribe',
			cancelText: 'Cancel',
			clearModal: true,
			enableWallets: false,
		});

		if (cardError) {
			showModalErrorText($cardModal, cardError);
		}

		applyCardModalStylingChanges();
	};

	const applyCardModalStylingChanges = () => {
		$('.js-card-payment-modal .modal-title')
			.removeClass('text-center')
			.addClass('text-left')
			.removeClass('px-3')
			.addClass('p-0');

		$('.js-card-payment-modal .modal-body').addClass('px-4');

		$('.js-card-payment-modal .js-card-modal-cancel').addClass(
			'btn btn-outline-clear bark-btn',
		);
		$('.js-card-payment-modal .js-card-modal-confirm')
			.removeClass('btn-success')
			.addClass('btn-primary bark-btn');

		$('.js-card-payment-modal .secure-footer').addClass('rounded-bottom');
	};

	const onCardModalSuccess = async (token) => {
		$('#cs-sub-payment-processing-modal').modal('show');

		try {
			await confirmSetupIntent($cardModal.data('user-id'), token.id);
			chargeSelectedPackage();
		} catch (error) {
			handlePaymentError(error);
		}
	};

	const showPaymentSummaryModal = () => {
		const csSubscriptionPaymentSummaryModal = CsSubscriptionPaymentSummaryModal();
		csSubscriptionPaymentSummaryModal.show(
			currencySymbol,
			paymentMethod,
			selectedPackage,
			selectedPaymentFrequency,
			onPaymentSummaryModalSuccess,
			onPaymentSummaryModalChangeCard,
		);
	};

	const onPaymentSummaryModalSuccess = () => {
		$('#cs-sub-payment-processing-modal').modal('show');
		chargeSelectedPackage();
	};

	const onPaymentSummaryModalChangeCard = () => {
		showCardModal(true);
	};

	const chargeSelectedPackage = async () => {
		try {
			let chargeResponse = {};

			if (selectedPackage?.uuid) {
				chargeResponse = await createSubscriptionForPrebuiltPackage(
					false,
					selectedPackage.uuid,
				);
			} else {
				chargeResponse = await createSubscriptionForPackage(
					false,
					selectedPackage.name,
					selectedPaymentFrequency,
					selectedPackage?.n_leads,
				);
			}

			if (chargeResponse?.data && chargeResponse.data?.stripe_subscription_id) {
				if (chargeResponse.data?.client_secret) {
					await refreshPaymentMethod();
					const result = await retryIntent(
						chargeResponse.data.client_secret,
						paymentMethod?.id,
					);
				}

				tracking(
					'credit-subscription-self-service-page-checkout',
					'payment_success',
					trackingPayload,
				);
				sendChameleonAndHeapTrackEvent('Credit subscription self service page converted');

				if (selectedPackage?.uuid) {
					await deleteSubscriptionForPrebuiltPackage(false, selectedPackage.uuid);
				}

				$('#cs-sub-payment-processing-modal').modal('hide');
				showThankyouMessage();
				return;
			}

			handlePaymentError();
			return;
		} catch (error) {
			handlePaymentError(error);
		}
	};

	const handlePaymentError = async (error) => {
		await refreshPaymentMethod();
		$('#cs-sub-payment-processing-modal').modal('hide');

		let csPhoneNum = '';
		if (window?.Bark?.ENV?.ccid === 236) {
			csPhoneNum = '020 3697 0237';
		}
		if (window?.Bark?.ENV?.ccid === 237) {
			csPhoneNum = '(424) 227-5323';
		}

		const errorMsg = `There was a problem taking your payment and you haven't been charged. Try again with a different card, or speak to our support team${
			csPhoneNum ? ` on ${csPhoneNum}` : '.'
		}`;

		showCardModal(true, errorMsg);

		tracking(
			'credit-subscription-self-service-page-checkout',
			'payment_fail',
			trackingPayload,
		);
		sendChameleonAndHeapTrackEvent(
			'Credit subscription self service page conversion failed for payment issue',
		);

		if (error) {
			window.bugsnagClient &&
				window.bugsnagClient.notify(
					new Error('Failed payment on credit subscription self service page'),
					{
						metaData: { err: error },
					},
				);
		}
	};

	const addPackage = (packageData) => {
		packages.push(packageData);
	};

	const removePackage = (packageName) => {
		const index = packages.findIndex((item) => {
			return item.name === packageName;
		});
		if (index >= 0) packages.splice(index, 1);
	};

	const updateSelectedPaymentFrequency = (paymentFrequency) => {
		selectedPaymentFrequency = paymentFrequency;
	};

	const getSelectedPaymentFrequency = () => {
		return selectedPaymentFrequency;
	};

	return {
		init,
		processPaymentForPackage,
		addPackage,
		removePackage,
		updateSelectedPaymentFrequency,
		getSelectedPaymentFrequency,
	};
}
